var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAffIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 44,
    viewBox: "0 0 46 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6180_13479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.20605 25.1084C9.65872 24.0287 11.2493 24.0577 11.627 25.2158L12.3242 27.3682H12.3252C12.3379 27.4045 12.3734 27.4297 12.4092 27.4297H14.6738C15.8882 27.4298 16.4178 28.9362 15.5273 29.7002L15.4365 29.7715L13.6055 31.1025H13.6045C13.5725 31.1257 13.5604 31.1646 13.5723 31.2012L14.2734 33.3525V33.3535L14.3047 33.4648C14.5637 34.5729 13.3426 35.4556 12.375 34.8662L12.2793 34.8018L10.4473 33.4707H10.4463C10.4165 33.4487 10.3758 33.4495 10.3496 33.4688L10.3486 33.4697L8.51465 34.8018C7.4948 35.5368 6.13823 34.5463 6.51953 33.3555L7.22168 31.2002L7.22656 31.1729C7.22643 31.1459 7.21352 31.1201 7.19043 31.1035H7.18945L5.35645 29.7715V29.7705C4.34171 29.0326 4.86901 27.4299 6.12012 27.4297H8.38086C8.41999 27.4297 8.45339 27.4052 8.46484 27.3701V27.3691L9.16602 25.2168V25.2158L9.20605 25.1084ZM10.4805 25.5889C10.4571 25.5178 10.3669 25.5072 10.3262 25.5635L10.3125 25.5908L9.61133 27.7422C9.43792 28.2762 8.94315 28.6357 8.38086 28.6357H6.12012C6.03219 28.6359 5.99892 28.7464 6.06543 28.7949L7.89746 30.126L7.97949 30.1904C8.37547 30.5272 8.53237 31.0704 8.36914 31.5732V31.5742L7.66797 33.7266C7.64211 33.8077 7.73377 33.8774 7.80762 33.8242L9.63672 32.4951L9.72461 32.4365C10.1712 32.1612 10.7368 32.1871 11.1582 32.4961L12.9883 33.8252L13.0146 33.8389C13.0788 33.8585 13.1492 33.7989 13.126 33.7246L12.4248 31.5742L12.417 31.5527V31.5449C12.2589 31.0166 12.4487 30.449 12.8975 30.125L14.7275 28.7949L14.748 28.7744C14.7803 28.7284 14.7599 28.6595 14.7041 28.6406L14.6738 28.6357H12.4092C11.8532 28.6357 11.3602 28.2783 11.1807 27.749L11.1797 27.7471L10.4805 25.5889Z",
    fill: "url(#paint0_linear_6180_13479)",
    stroke: "url(#paint1_linear_6180_13479)",
    strokeWidth: 0.293333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5801 25.1064C22.0221 24.0542 23.618 24.0332 24.0029 25.2109L24.6992 27.3623H24.7002C24.7126 27.3986 24.748 27.4247 24.7842 27.4248H27.0488C28.2622 27.4248 28.7935 28.9315 27.9033 29.6953L27.8125 29.7666L25.9805 31.0967L25.959 31.1182C25.9426 31.1407 25.9384 31.1691 25.9473 31.1963L26.6484 33.3477V33.3486L26.6797 33.46C26.9379 34.5664 25.718 35.4504 24.75 34.8604L24.6543 34.7969L22.8223 33.4658L22.8213 33.4648C22.7923 33.4436 22.7518 33.4444 22.7236 33.4648H22.7227L20.8896 34.7969C19.8719 35.5316 18.5127 34.5427 18.8955 33.3506V33.3496L19.5967 31.1953L19.6016 31.168C19.6015 31.1407 19.5882 31.1152 19.5654 31.0986V31.0977L17.7314 29.7666V29.7656C16.7166 29.0277 17.244 27.425 18.4951 27.4248H20.7559C20.7951 27.4248 20.8285 27.3994 20.8398 27.3643L21.541 25.2109L21.5801 25.1064ZM22.8555 25.583C22.8274 25.5028 22.7158 25.5023 22.6885 25.5859L21.9873 27.7383C21.8138 28.2718 21.318 28.6309 20.7559 28.6309H18.4951C18.4073 28.6311 18.374 28.7415 18.4404 28.79L20.2734 30.1211H20.2725C20.7281 30.45 20.9179 31.0321 20.7441 31.5684V31.5693L20.043 33.7217C20.0176 33.801 20.1077 33.8732 20.1826 33.8193L22.0127 32.4902L22.0996 32.4316C22.5431 32.159 23.1073 32.1789 23.5332 32.4912L25.3633 33.8203L25.3896 33.834C25.4535 33.8535 25.5242 33.7941 25.501 33.7197L24.7998 31.5693L24.792 31.5479V31.54C24.6334 31.0115 24.8236 30.4441 25.2725 30.1201L27.1035 28.79L27.124 28.7695C27.1555 28.7238 27.1354 28.6547 27.0801 28.6357L27.0488 28.6309H24.7842C24.2279 28.6308 23.7351 28.2734 23.5557 27.7441L23.5547 27.7422L22.8555 25.584V25.583Z",
    fill: "url(#paint2_linear_6180_13479)",
    stroke: "url(#paint3_linear_6180_13479)",
    strokeWidth: 0.293333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9551 25.1064C34.3971 24.0544 35.992 24.0332 36.377 25.2109H36.3779L37.0742 27.3623L37.0879 27.3877C37.1049 27.4102 37.132 27.4248 37.1592 27.4248H39.4238C40.6382 27.4249 41.1681 28.9316 40.2773 29.6953L40.1865 29.7666L38.3555 31.0977H38.3545C38.3225 31.1209 38.3104 31.1598 38.3223 31.1963L39.0234 33.3486L39.0547 33.4609C39.3137 34.5706 38.0905 35.4483 37.125 34.8604L37.0293 34.7969L35.1973 33.4658H35.1963C35.1744 33.4497 35.1459 33.4454 35.1211 33.4531L35.0977 33.4648L33.2646 34.7969C32.246 35.5314 30.8868 34.5426 31.2695 33.3506V33.3496L31.9717 31.1963V31.1953L31.9756 31.168C31.9755 31.1408 31.9631 31.1152 31.9404 31.0986L31.9395 31.0977L30.1064 29.7666C29.0951 29.0326 29.6129 27.4248 30.8701 27.4248H33.1309C33.1704 27.4247 33.2027 27.3998 33.2139 27.3652L33.916 25.2109L33.9551 25.1064ZM35.2168 25.5576C35.1766 25.5036 35.0866 25.5123 35.0625 25.5859L34.3613 27.7373C34.1888 28.2711 33.6938 28.6308 33.1309 28.6309H30.8701C30.7809 28.6309 30.7495 28.7423 30.8154 28.79L32.6475 30.1211L32.7295 30.1855C33.0988 30.5002 33.2602 30.9945 33.1475 31.4678L33.1191 31.5684L32.418 33.7217C32.3922 33.8039 32.4847 33.8717 32.5576 33.8193L34.3867 32.4902L34.4736 32.4316C34.9173 32.1587 35.4826 32.1793 35.9082 32.4912L37.7383 33.8203H37.7373C37.806 33.87 37.9023 33.8041 37.875 33.7188V33.7178L37.1748 31.5693L37.167 31.5469V31.54C37.0083 31.0113 37.1988 30.4439 37.6475 30.1201L39.4775 28.79H39.4785L39.498 28.7695C39.5301 28.7237 39.5104 28.6545 39.4541 28.6357L39.4238 28.6309H37.1592C36.6028 28.6309 36.1092 28.2735 35.9297 27.7441V27.7422L35.2305 25.585L35.2168 25.5576Z",
    fill: "url(#paint4_linear_6180_13479)",
    stroke: "url(#paint5_linear_6180_13479)",
    strokeWidth: 0.293333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4648 11.125C32.6827 11.125 34.4871 12.9281 34.4873 15.1445C34.4873 17.3624 32.6827 19.167 30.4648 19.167C28.2484 19.1668 26.4453 17.3623 26.4453 15.1445C26.4455 12.9282 28.2485 11.1252 30.4648 11.125ZM30.4648 12.0381C28.7519 12.0383 27.3587 13.4317 27.3584 15.1445C27.3584 16.859 28.7518 18.2537 30.4648 18.2539C32.1795 18.2539 33.5752 16.8592 33.5752 15.1445C33.575 13.4316 32.1793 12.0381 30.4648 12.0381Z",
    fill: "url(#paint6_linear_6180_13479)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4648 11.125C32.6827 11.125 34.4871 12.9281 34.4873 15.1445C34.4873 17.3624 32.6827 19.167 30.4648 19.167C28.2484 19.1668 26.4453 17.3623 26.4453 15.1445C26.4455 12.9282 28.2485 11.1252 30.4648 11.125ZM30.4648 12.0381C28.7519 12.0383 27.3587 13.4317 27.3584 15.1445C27.3584 16.859 28.7518 18.2537 30.4648 18.2539C32.1795 18.2539 33.5752 16.8592 33.5752 15.1445C33.575 13.4316 32.1793 12.0381 30.4648 12.0381Z",
    stroke: "url(#paint7_linear_6180_13479)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8926 5.70508C34.102 5.70508 38.3407 9.94028 38.3408 15.1465C38.3408 17.3878 37.5499 19.4438 36.2412 21.0645H39.7822C42.14 21.0645 44.0576 22.9823 44.0576 25.3398V34.0254C44.0574 36.383 42.1398 38.3008 39.7822 38.3008H5.76562C3.4079 38.3008 1.49042 36.383 1.49023 34.0254V25.3398C1.49023 22.9823 3.40788 21.0645 5.76562 21.0645H21.5488C21.0545 20.4518 20.6353 19.7775 20.3047 19.0527H4.17383C3.71055 19.0527 3.25807 18.91 2.87988 18.6475L2.72266 18.5273L0.755859 16.8896C-0.331487 15.9849 -0.330944 14.3172 0.748047 13.4111C0.752566 13.4068 0.755779 13.403 0.757812 13.4014C0.759838 13.3997 0.762007 13.3987 0.763672 13.3975L2.72461 11.7705L2.88184 11.6514C3.26039 11.3894 3.7128 11.2471 4.17578 11.2471H5.59082C6.22311 11.2471 6.81395 11.5291 7.21094 12.0205L8.30859 13.376V13.377L8.3877 13.4551C8.58775 13.6107 8.88928 13.5845 9.05859 13.376L10.3594 11.7686L10.4658 11.6514C10.7279 11.3929 11.0801 11.2471 11.4531 11.2471H12.0605C12.4872 11.2471 12.8862 11.437 13.1543 11.7686L14.4551 13.376L14.5342 13.4541C14.7362 13.6103 15.0383 13.5848 15.2031 13.3789V13.3779L16.2891 12.0352L16.4502 11.8584C16.8457 11.4676 17.3781 11.2471 17.9424 11.2471H20.3027C21.7901 7.9836 25.0768 5.7052 28.8926 5.70508ZM5.76562 22.2705C4.07364 22.2705 2.69629 23.6476 2.69629 25.3398V34.0254C2.69647 35.7175 4.07377 37.0947 5.76562 37.0947H39.7822C41.4741 37.0947 42.8514 35.7175 42.8516 34.0254V25.3398C42.8516 23.6477 41.4742 22.2705 39.7822 22.2705H35.0947C33.3873 23.7606 31.0953 24.5947 28.8926 24.5947C26.6609 24.5947 24.411 23.7678 22.6982 22.2705H5.76562ZM28.8926 6.91113C24.3118 6.91125 20.6574 10.6665 20.6572 15.1465L20.668 15.5693C20.8899 19.909 24.5102 23.3877 28.8945 23.3877C33.4031 23.3874 37.1348 19.7115 37.1348 15.1465C37.1346 10.6057 33.4369 6.91113 28.8926 6.91113ZM4.17578 12.4531C3.95869 12.4531 3.74585 12.5198 3.56836 12.6426L3.49512 12.6992L1.52734 14.3311C1.01847 14.7547 1.01805 15.539 1.52734 15.9629L3.49414 17.6006L3.56836 17.6562C3.74541 17.7791 3.95705 17.8457 4.17383 17.8457H19.8418C19.606 17.0408 19.4502 16.0353 19.4502 15.1465C19.4502 14.2243 19.6155 13.2245 19.8418 12.4531H17.9424C17.6979 12.4531 17.468 12.5487 17.2969 12.7178L17.2275 12.7939L16.1416 14.1338L16.1426 14.1348C15.5172 14.9146 14.3542 14.9694 13.6514 14.2832L13.5176 14.1357L12.2158 12.5273C12.1779 12.4804 12.1215 12.4532 12.0605 12.4531H11.4521C11.4068 12.4532 11.3634 12.4684 11.3281 12.4961L11.2959 12.5283L9.99512 14.1348V14.1357C9.3181 14.9698 8.04099 14.9703 7.36914 14.1328V14.1338L6.27246 12.7793C6.10512 12.5724 5.85728 12.4532 5.59082 12.4531H4.17578Z",
    fill: "url(#paint8_linear_6180_13479)",
    stroke: "url(#paint9_linear_6180_13479)",
    strokeWidth: 0.293333
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6180_13479",
    x1: 4.96875,
    y1: 29.6879,
    x2: 15.825,
    y2: 29.6879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2069FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003CB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6180_13479",
    x1: 4.96875,
    y1: 29.6879,
    x2: 15.825,
    y2: 29.6879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2069FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003CB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6180_13479",
    x1: 17.3438,
    y1: 29.6853,
    x2: 28.2002,
    y2: 29.6853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2069FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003CB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6180_13479",
    x1: 17.3438,
    y1: 29.6853,
    x2: 28.2002,
    y2: 29.6853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2069FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003CB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6180_13479",
    x1: 29.7188,
    y1: 29.6853,
    x2: 40.5752,
    y2: 29.6853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2069FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003CB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6180_13479",
    x1: 29.7188,
    y1: 29.6853,
    x2: 40.5752,
    y2: 29.6853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2069FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003CB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6180_13479",
    x1: 26.4453,
    y1: 15.1461,
    x2: 34.4878,
    y2: 15.1461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2069FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003CB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6180_13479",
    x1: 26.4453,
    y1: 15.1461,
    x2: 34.4878,
    y2: 15.1461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2069FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003CB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6180_13479",
    x1: 0.0859375,
    y1: 22.0027,
    x2: 43.9109,
    y2: 22.0027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2069FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003CB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6180_13479",
    x1: 0.0859375,
    y1: 22.0027,
    x2: 43.9109,
    y2: 22.0027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2069FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003CB7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6180_13479"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.2941,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffIcon1);
export default __webpack_public_path__ + "static/media/affIcon1.948752cfa5a4542330274312c992a101.svg";
export { ForwardRef as ReactComponent };